import type {
  MethodologiesForPropertyResponse,
  MethodologyByCompanyResponse,
  MethodologyEntity,
  MethodologyPayload
} from '@protector/entities/methodology/models';
import type { CommandRequest, UUID } from '@protector/utils/types';
import axios from 'axios-observable';
import { CORE_SERVICES_API_URL, PROTECTOR_API_URL } from 'config/constants';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { mapMethodologyForUpdate } from './methodology-v2.mapper';

const protectorApiUrl = PROTECTOR_API_URL;
const demeterMethodologyUrl = `${protectorApiUrl}/api/v1/methodologies`;
const METHODOLOGIES_BY_COMPANY_MAX_SIZE = 9999;

type getMethodologyByCompanyServiceType = (companyId: UUID) => Observable<MethodologyByCompanyResponse>;

export const getMethodologyByCompany: getMethodologyByCompanyServiceType = (companyId: UUID) => {
  const url = `${protectorApiUrl}/api/v1/methodologies/by-company/${companyId}?size=9999`;
  return axios
    .get<MethodologyByCompanyResponse>(url, {
      headers: {
        'X-Company-Id': companyId
      }
    })
    .pipe(map(response => response.data));
};

export const getMethodologyByCompanyShallow: getMethodologyByCompanyServiceType = (companyId: UUID) => {
  const url = `${protectorApiUrl}/api/v1/methodologies/by-company/${companyId}`;
  return axios
    .get<MethodologyByCompanyResponse>(url, {
      params: {
        size: METHODOLOGIES_BY_COMPANY_MAX_SIZE,
        shallow: true
      },
      headers: {
        'X-Company-Id': companyId
      }
    })
    .pipe(map(response => response.data));
};

export const getMethodologyById = (methodologyId: UUID): Observable<MethodologyEntity> => {
  return axios.get<MethodologyEntity>(`${demeterMethodologyUrl}/${methodologyId}`).pipe(map(response => response.data));
};

export const updateMethodology = (methodology: CommandRequest<MethodologyPayload>): Observable<MethodologyEntity> => {
  return axios
    .put<MethodologyEntity>(
      `${CORE_SERVICES_API_URL}/v2/methodologies/${methodology.payload.id}`,
      mapMethodologyForUpdate(methodology.payload.methodology_dto)
    )
    .pipe(map(response => response.data));
};

export const getMethodologiesForProperty = (propertyId?: UUID) => {
  if (!propertyId) return of([]);
  return axios
    .get<MethodologiesForPropertyResponse[]>(`${protectorApiUrl}/v1/methodologies/property/${propertyId}`)
    .pipe(map(meth => meth.data));
};

export const getMethodologiesForPropertySeason = (propertyId: UUID, seasonId: UUID) => {
  return axios
    .get<MethodologiesForPropertyResponse[]>(`${protectorApiUrl}/v1/methodologies/property/${propertyId}/season/${seasonId}`)
    .pipe(map(meth => meth.data));
};
